




































































import Vue from "vue";
import { mapGetters } from "vuex";
import router from "./router";

export default Vue.extend({
  name: "App",

  components: {},
  computed: {
    ...mapGetters("draftDeck", {
      loading: "loading",
    }),
  },
  data: () => ({
    //
  }),
  methods: {
    create() {
      this.$store.dispatch("draftDeck/createDraftDeck");
    },
  },
});
